import { render, staticRenderFns } from "./BusinessInformationEvents.vue?vue&type=template&id=070b5ae2"
import script from "./BusinessInformationEvents.vue?vue&type=script&lang=js"
export * from "./BusinessInformationEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports